// Token Management
export function getToken() {
  return sessionStorage.getItem("ROCP_token") ?? null;
}

// Device Key Management
export function getDeviceKey(name: string) {
  return sessionStorage.getItem(name);
}

export function saveDeviceKey(name: string, value: string) {
  sessionStorage.setItem(name, value);
}

// Pre Login Path Management
export function savePreLoginPath(pathname: string) {
  localStorage.setItem("preLoginPath", pathname);
}

export function getPreLoginPath() {
  return localStorage.getItem("preLoginPath") ?? "";
}

// OAuth Redirect Tracking
// Safari clears window.name on cross-origin navigation, so the duplicate-tab guard
// can't rely on it alone to tell "returning from our own OAuth redirect" apart from
// "a genuinely new/duplicated tab". This flag bridges that gap.
export function markOAuthRedirectPending() {
  sessionStorage.setItem("oauthRedirectPending", "1");
}

export function consumeOAuthRedirectPending() {
  const pending = sessionStorage.getItem("oauthRedirectPending") === "1";
  sessionStorage.removeItem("oauthRedirectPending");
  return pending;
}
